import React from 'react'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'

import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers'

import Container from './Container'

const theme = createMuiTheme({
  props: {
    MuiButtonBase: {
      disableRipple: true,
    }
  },
  palette: {
    primary: {
      main: '#1E478C',
    },
    secondary: {
      // main: '#AAD284'
      main: '#FFF',
    },
  },
})

class App extends React.Component {
  render() {
    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <MuiThemeProvider theme={theme}>
          <Container />
        </MuiThemeProvider>
      </MuiPickersUtilsProvider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js